import { Document, Image, Page, Text, View } from "@react-pdf/renderer"
import { Assets } from "../assets"
import { TRIP_STATUSES, TripStatus } from "../constants/general.constant"
import { Colors } from "../constants/colors.constants"
import { getResourceUrl } from "../constants/endpoint.constant"
import { formatInspectionDate, formatInspectionDateTime, formatInspectionTime, normalizeInspectionChoiceState, normalizeInspectionRecord } from "../utils/inspection.util";
import { getTripReference } from "../utils/tripReference.util";
import { formatDateTimeZA, formatDateZA, formatTimeZA } from "../utils/date.util";

const getPdfImageSource = resource => {
    const uri = getResourceUrl(resource);
    if (!uri) return null;
    if (/^data:image\//i.test(uri)) return uri;
    return { uri };
}

const PdfImage = ({ resource, ...props }) => {
    const source = getPdfImageSource(resource);
    if (!source) return null;
    return <Image src={source} {...props} />
}

export const TripOrderDoc = ({ tripOrder, acceptedStatus }) => {
    return <Document>
        <TripOrderCard trip={tripOrder} acceptedStatus={acceptedStatus} />

    </Document >
}
export const CancelDoc = ({ trip }) => {
    return <Document>
        <CancelPage trip={trip} />
    </Document>
}
const CancelPage = ({ trip }) => {
    return <Page size="A4">
        <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
            <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
            <Text>Trip Order - MYC#{trip?.id}</Text>
            <Text>Cancel Reason:{trip?.cancelledTrips[0]?.reason}</Text>
            <PdfImage resource={trip?.cancelledTrips[0]?.image} style={{ height: 250, width: 250, objectFit: 'contain' }} />

        </View>
    </Page>
}
const TwoRowCol = ({ label, children }) => {
    return <View style={{ flexDirection: 'col', flex: 1, alignItems: 'flex-start', }}>
        <Text style={{ fontSize: 12, marginBottom: 10 }}>{label}</Text>
        <Text style={{ fontSize: 12 }}>{children}</Text>
    </View>
}
const Divider = () => {
    return <View style={{ height: 1, width: '100%', backgroundColor: 'gray', marginTop: 20, marginBottom: 20 }} color="gray" />
}
const TripOrderCard = ({ trip, acceptedStatus }) => {
    const tripReference = getTripReference(trip);
    return <Page size="A4">
        <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
            <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />

            <Text style={{ marginBottom: 10 }}>Trip: MYC#{trip?.id}</Text>
            <Divider />
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%', gap: 10 }}>
                <TwoRowCol label="Client Name" >{trip?.client?.user?.name}</TwoRowCol>
                <TwoRowCol label="MYC Reference Number" >{tripReference}</TwoRowCol>
                <TwoRowCol label="Date" >{formatDateZA(trip?.startDateTime)}</TwoRowCol>
                <TwoRowCol label="Trip Status" >{TRIP_STATUSES[trip?.status]}</TwoRowCol>
                <TwoRowCol label="Price" >R{trip?.price?.toFixed(2)}</TwoRowCol>
            </View>
            <Divider />
            <View style={{ flexDirection: 'row', width: '100%', gap: 10 }}>
                <TwoRowCol label="Vehicle Reg No" >{trip?.vehicleRegNumber}</TwoRowCol>
                <TwoRowCol label="Vehicle Type" >Polo</TwoRowCol>
                <TwoRowCol label="Pickup Location" >{trip?.pickUp}</TwoRowCol>
                <TwoRowCol label="Dropoff Location" >{trip?.dropOff}</TwoRowCol>

            </View>
            <Divider />

            <View style={{ flexDirection: 'row', width: '100%', gap: 10 }}>
                <TwoRowCol label="Start Date" >{formatDateZA(trip?.startDateTime)}</TwoRowCol>
                <TwoRowCol label="Start Time" >{formatTimeZA(trip?.startDateTime)}</TwoRowCol>
                <TwoRowCol label="Total KM" >{trip?.totalKM?.toFixed?.(2)}KM</TwoRowCol>
                <TwoRowCol label="MYC Ref No" >{tripReference}</TwoRowCol>

            </View>
            <Divider />
            {trip?.driver && <View style={{ flexDirection: 'row', width: '100%', gap: 10 }}>
                <TwoRowCol label="Driver Name" >{trip?.driver?.user?.name}</TwoRowCol>
                <TwoRowCol label="Time of Acceptance" >{formatTimeZA(acceptedStatus?.createdAt)}</TwoRowCol>
                <TwoRowCol label="Date of Acceptance" >{formatDateZA(acceptedStatus?.createdAt)}</TwoRowCol>
                <TwoRowCol label="Status" >{"Accepted"}</TwoRowCol>
            </View>}
            <Divider />
            <View style={{ flexDirection: 'row', width: '100%', gap: 10 }}>
                <TwoRowCol label="Driver Acceptance Message" >{trip?.driverAcceprtanceMessage ? "Sent" : "Pending"}</TwoRowCol>
                <TwoRowCol label="Driver Started Trip Message" >{trip?.driverStartedTripMessage ? "Sent" : "Pending"}</TwoRowCol>
                <TwoRowCol label="Driver Started Trip Message" >{trip?.tripCompletedMessage ? "Sent" : "Pending"}</TwoRowCol>

            </View>
            <Divider />
            <Text>Trip Status: <Text style={{ color: 'red', marginBottom: 10 }}>{TRIP_STATUSES[trip?.status]}</Text></Text>
            <Text>Trip Order Live Status</Text>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 5, marginTop: 8 }}>
                <Text style={{ fontSize: 10, color: trip?.status === TripStatus.DriverAccepted ? 'red' : undefined }}  > 1 - Order Accepted</Text>
                <Text style={{ fontSize: 10, color: false ? 'red' : undefined }} color={false ? 'red' : undefined} > 2 - Pre inspection</Text>
                <Text style={{ fontSize: 10, color: trip?.status === TripStatus.TripStarted ? 'red' : undefined }} color={trip?.status === TripStatus.TripStarted ? 'red' : undefined} > 3 - On Route</Text>
                <Text style={{ fontSize: 10, color: trip?.status === TripStatus.PostInspection ? 'red' : undefined }} > 4 - Post inspection</Text>
                <Text style={{ fontSize: 10, color: trip?.status === TripStatus.Completed ? 'red' : undefined }} > 5 - Completed</Text>
            </View>
        </View>
    </Page >
}

const FieldPara = ({ label, children, height, value, style }) => {
    return <View style={{ flexDirection: 'col', gap: 3, ...(style ?? {}) }}>
        <Text style={{ fontSize: 12, alignSelf: 'center' }}>{label}</Text>
        <View style={{ border: 1, height, borderStyle: 'solid', alignSelf: 'stretch', textAlign: 'center', paddingHorizontal: 5, paddingVertical: 3 }}>
            <Text style={{ fontSize: 12 }}>{value || children}</Text>
        </View>
    </View>
}

const MyText = ({ children }) => <Text style={{ fontSize: 12 }}>{children}</Text>
const ChoiceBox = ({ checked }) => <View style={{
    backgroundColor: checked ? Colors.primaryOrange : undefined,
    width: 15,
    height: 15,
    border: 1,
    borderStyle: 'solid',
    borderColor: 'black',
}} />
const ChoiceView = ({ label, yes, yesLabel = "Yes", noLabel = "No", style }) => {
    const choice = normalizeInspectionChoiceState(yes);

    return <View style={{ flexDirection: 'col', gap: 3, alignItems: 'center', ...(style ?? {}) }} className="flex flex-col gap-3 items-center">
        <MyText >{label}</MyText>
        <View style={{ border: 1, borderStyle: 'solid', flexDirection: 'row', justifyContent: 'space-between', gap: 10, paddingHorizontal: 10, paddingVertical: 5 }}
        >
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                <MyText>{yesLabel}</MyText>
                <ChoiceBox checked={choice === true} />
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                <MyText>{noLabel}</MyText>
                <ChoiceBox checked={choice === false} />
            </View>
        </View>
    </View>
}
const VehicleReviewBlock = ({ label, width = '100%', windscreen, image, dent, scratch, comment }) => {
    return <View style={{ flexDirection: 'column', gap: 5, width: width, justifyContent: 'flex-start' }} className="flex flex-col gap-5">
        <Text style={{ backgroundColor: Colors.primaryOrange, paddingHorizontal: 5, paddingVertical: 10, fontSize: 12, color: 'white', textAlign: 'center' }}>
            {label}
        </Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 5 }}>
            {image?.map?.((M, index) => <PdfImage key={`${label}-image-${index}`} resource={M?.pic} style={{ objectFit: 'contain', width: '100%', height: 300 }} className="object-contain" />)}
        </View>
        {!windscreen && <>
            <ChoiceView label="Dent" yes={dent} />
            <ChoiceView label="Scratch" yes={scratch} />
        </>}
        <FieldPara height={70} label="Comments" value={comment} />
    </View>
}

const TyreReviewBlock = ({ label, image, width = "100%", tread, pressure, make }) => {
    return <View style={{ flexDirection: 'column', gap: 5, width: width, justifyContent: 'flex-start' }} className="flex flex-col gap-5">
        <Text style={{ backgroundColor: Colors.primaryOrange, paddingHorizontal: 5, paddingVertical: 10, fontSize: 12, color: 'white', textAlign: 'center' }}>
            {label}
        </Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 5 }}>
            {image?.map?.((M, index) => <PdfImage key={`${label}-image-${index}`} resource={M?.pic} style={{ objectFit: 'contain', height: 300, width: '100%' }} className="object-contain" />)}
        </View>
        <ChoiceView label="Tread" yesLabel="Good" noLabel="Bad" yes={tread} />
        <ChoiceView label="Pressure" yes={pressure} />
        <FieldPara label="Make" value={make} />
    </View>
}

const compact = value => value === null || value === undefined || value === "" ? "Not available" : value;
const compactBool = value => {
    const choice = normalizeInspectionChoiceState(value);
    if (choice === true) return "Yes";
    if (choice === false) return "No";
    return "Not available";
}
const metricValue = value => Number.isFinite(Number(value)) ? Number(value).toFixed(1) : "0";
const compactDate = value => {
    if (!value) return "Not available";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "Not available" : formatDateTimeZA(date);
}
const reportStyles = {
    page: { padding: 26, fontSize: 8, color: "#221f1c", backgroundColor: "#fbfaf8" },
    header: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 12 },
    logo: { width: 54, height: 34, objectFit: "contain" },
    title: { fontSize: 18, color: "#161311" },
    subtitle: { fontSize: 8, color: "#6e6258", marginTop: 3 },
    section: { marginTop: 10, padding: 10, border: 1, borderColor: "#e7ded6", backgroundColor: "#ffffff" },
    sectionTitle: { fontSize: 11, color: Colors.primaryOrange, marginBottom: 7 },
    grid: { flexDirection: "row", flexWrap: "wrap", gap: 6 },
    cell: { width: "24%", padding: 6, border: 1, borderColor: "#eee5dc", backgroundColor: "#fcfaf7", minHeight: 32 },
    half: { width: "49%" },
    label: { fontSize: 6, color: "#806f61", marginBottom: 3, textTransform: "uppercase" },
    value: { fontSize: 8, color: "#161311" },
    badge: { paddingHorizontal: 6, paddingVertical: 4, backgroundColor: "#f4eee9", color: "#161311", fontSize: 8 },
    imageBox: { width: "24%", height: 80, border: 1, borderColor: "#e7ded6", backgroundColor: "#f8f4f0", alignItems: "center", justifyContent: "center", padding: 2 },
    image: { width: "100%", height: "100%", objectFit: "contain" },
    emptyImage: { fontSize: 7, color: "#8c7b6b" },
    tableHeader: { flexDirection: "row", paddingVertical: 4, borderBottom: 1, borderColor: "#e7ded6" },
    tableRow: { flexDirection: "row", paddingVertical: 4, borderBottom: 1, borderColor: "#f0e9e2" },
    th: { fontSize: 6, color: "#806f61", textTransform: "uppercase" },
    td: { fontSize: 7, color: "#161311" },
}

const ReportHeader = ({ title, trip }) => <View style={reportStyles.header} fixed>
    <View>
        <Text style={reportStyles.title}>{title}</Text>
        <Text style={reportStyles.subtitle}>MYC#{trip?.id || "Not available"} | Ref {getTripReference(trip) || "Not available"} | Generated {formatDateTimeZA(Date.now())}</Text>
    </View>
    <Image src={{ uri: Assets.LogoDark }} style={reportStyles.logo} />
</View>

const InfoCell = ({ label, value, style }) => <View style={{ ...reportStyles.cell, ...(style ?? {}) }}>
    <Text style={reportStyles.label}>{label}</Text>
    <Text style={reportStyles.value}>{compact(value)}</Text>
</View>

const Section = ({ title, children, style }) => <View style={{ ...reportStyles.section, ...(style ?? {}) }}>
    <Text style={reportStyles.sectionTitle}>{title}</Text>
    {children}
</View>

const ComplianceSummary = ({ compliance }) => {
    const summary = compliance?.summary || {};
    const speeding = compliance?.infringements || [];
    const offline = compliance?.offlineInfringements || [];
    const provider = compliance?.provider || {};
    return <Section title="Over-Speeding And Offline Indicators">
        <View style={reportStyles.grid}>
            <InfoCell label="Speeding events" value={summary?.speedingEventCount ?? speeding.length ?? 0} />
            <InfoCell label="Offline events" value={summary?.offlineInfringementCount ?? offline.length ?? 0} />
            <InfoCell label="Max speed" value={summary?.maxSpeedKph ? `${metricValue(summary.maxSpeedKph)} km/h` : "Not available"} />
            <InfoCell label="Provider" value={provider?.name || "driver-tracking-telemetry"} />
        </View>
        <View style={{ marginTop: 7 }}>
            <View style={reportStyles.tableHeader}>
                <Text style={{ ...reportStyles.th, width: "24%" }}>Type</Text>
                <Text style={{ ...reportStyles.th, width: "24%" }}>When</Text>
                <Text style={{ ...reportStyles.th, width: "18%" }}>Speed</Text>
                <Text style={{ ...reportStyles.th, width: "34%" }}>Road / Status</Text>
            </View>
            {speeding.slice(0, 4).map((event, index) => <View key={`speed-${index}`} style={reportStyles.tableRow}>
                <Text style={{ ...reportStyles.td, width: "24%" }}>Speeding</Text>
                <Text style={{ ...reportStyles.td, width: "24%" }}>{compactDate(event?.startTime)}</Text>
                <Text style={{ ...reportStyles.td, width: "18%" }}>{metricValue(event?.maxSpeedKph)} km/h</Text>
                <Text style={{ ...reportStyles.td, width: "34%" }}>{event?.roadName || event?.roadAddress || event?.status || "Road lookup pending"}</Text>
            </View>)}
            {offline.slice(0, 2).map((event, index) => <View key={`offline-${index}`} style={reportStyles.tableRow}>
                <Text style={{ ...reportStyles.td, width: "24%" }}>Offline</Text>
                <Text style={{ ...reportStyles.td, width: "24%" }}>{compactDate(event?.checkpointTime || event?.startTime)}</Text>
                <Text style={{ ...reportStyles.td, width: "18%" }}>-</Text>
                <Text style={{ ...reportStyles.td, width: "34%" }}>{event?.classification || event?.outageStatus || event?.status || "Logged"}</Text>
            </View>)}
            {!speeding.length && !offline.length ? <Text style={{ ...reportStyles.td, paddingTop: 5 }}>No over-speeding or offline indicators logged for this trip.</Text> : null}
        </View>
    </Section>
}

const compareStyles = {
    row: { flexDirection: "row", gap: 8, marginBottom: 8 },
    column: { width: "49%", padding: 8, border: 1, borderColor: "#e7ded6", backgroundColor: "#ffffff" },
    columnTitle: { fontSize: 12, color: "#161311", marginBottom: 7 },
    fieldGrid: { flexDirection: "row", flexWrap: "wrap", gap: 5 },
    field: { width: "49%", padding: 5, border: 1, borderColor: "#eee5dc", backgroundColor: "#fcfaf7", minHeight: 28 },
    imageRow: { flexDirection: "row", gap: 5, marginBottom: 6 },
    imageBox: { width: "49%", height: 95, border: 1, borderColor: "#e7ded6", backgroundColor: "#f8f4f0", alignItems: "center", justifyContent: "center", padding: 2 },
    fullImageBox: { width: "100%", height: 110, border: 1, borderColor: "#e7ded6", backgroundColor: "#f8f4f0", alignItems: "center", justifyContent: "center", padding: 2 },
    image: { width: "100%", height: "100%", objectFit: "contain" },
    sectionHeading: { fontSize: 13, color: Colors.primaryOrange, marginBottom: 8 },
    subsectionHeading: { fontSize: 10, color: "#161311", marginBottom: 5 },
    meta: { fontSize: 7, color: "#806f61", marginBottom: 3, textTransform: "uppercase" },
    value: { fontSize: 8, color: "#161311" },
};

const CompareField = ({ label, value }) => <View style={compareStyles.field}>
    <Text style={compareStyles.meta}>{label}</Text>
    <Text style={compareStyles.value}>{compact(value)}</Text>
</View>

const CompareImage = ({ resource, label, style }) => <View style={style || compareStyles.imageBox}>
    {resource ? <PdfImage resource={resource} style={compareStyles.image} /> : <Text style={reportStyles.emptyImage}>{label || "No image captured"}</Text>}
</View>

const CompareImageStrip = ({ images = [], label }) => {
    const visibleImages = Array.isArray(images) ? images.slice(0, 2) : [];
    return <View style={compareStyles.imageRow}>
        {visibleImages.length
            ? visibleImages.map((image, index) => <CompareImage key={`${label}-${index}`} resource={image?.pic || image?.image || image} />)
            : <CompareImage label="No image captured" style={compareStyles.fullImageBox} />}
    </View>
}

const CompareColumn = ({ title, children }) => <View style={compareStyles.column}>
    <Text style={compareStyles.columnTitle}>{title}</Text>
    {children}
</View>

const DisputeAreaColumn = ({ title, images, dent, scratch, comment }) => <View>
    <Text style={compareStyles.subsectionHeading}>{title}</Text>
    <CompareImageStrip label={title} images={images} />
    <View style={compareStyles.fieldGrid}>
        <CompareField label="Dent" value={compactBool(dent)} />
        <CompareField label="Scratch" value={compactBool(scratch)} />
        <CompareField label="Comments" value={comment} />
    </View>
</View>

const DisputeTyreColumn = ({ title, images, tread, pressure, make }) => <View>
    <Text style={compareStyles.subsectionHeading}>{title}</Text>
    <CompareImageStrip label={title} images={images} />
    <View style={compareStyles.fieldGrid}>
        <CompareField label="Tread" value={compactBool(tread)} />
        <CompareField label="Pressure" value={compactBool(pressure)} />
        <CompareField label="Make" value={make} />
    </View>
</View>

const CompareAreaRow = ({ title, pre, post }) => <View style={compareStyles.row} wrap={false}>
    <CompareColumn title={`Pre inspection - ${title}`}>
        <DisputeAreaColumn title={title} {...pre} />
    </CompareColumn>
    <CompareColumn title={`Post inspection - ${title}`}>
        <DisputeAreaColumn title={title} {...post} />
    </CompareColumn>
</View>

const CompareTyreRow = ({ title, pre, post }) => <View style={compareStyles.row} wrap={false}>
    <CompareColumn title={`Pre inspection - ${title}`}>
        <DisputeTyreColumn title={title} {...pre} />
    </CompareColumn>
    <CompareColumn title={`Post inspection - ${title}`}>
        <DisputeTyreColumn title={title} {...post} />
    </CompareColumn>
</View>

const SignOffColumn = ({ title, inspection }) => <CompareColumn title={title}>
    <View style={compareStyles.fieldGrid}>
        <CompareField label="E-tag" value={compactBool(inspection?.etag)} />
        <CompareField label="Tools & Jack" value={compactBool(inspection?.toolsAndJack)} />
        <CompareField label="Spare wheel" value={compactBool(inspection?.spareWheel)} />
        <CompareField label="Tow bar" value={compactBool(inspection?.towBar)} />
        <CompareField label="Company" value={inspection?.companyName} />
        <CompareField label="Dispatcher" value={inspection?.personName} />
        <CompareField label="Mobile" value={inspection?.number} />
        <CompareField label="Date" value={formatInspectionDateTime(inspection?.createdAt)} />
    </View>
    <Text style={{ ...compareStyles.subsectionHeading, marginTop: 8 }}>Signatures</Text>
    <View style={compareStyles.imageRow}>
        <CompareImage label="Driver signature" resource={inspection?.driverSignature} />
        <CompareImage label="Client signature" resource={inspection?.signature} />
    </View>
</CompareColumn>

export const CompareDocument = ({ inspect, postInspect, trip, compliance }) => {
    const preInspection = normalizeInspectionRecord(inspect, trip);
    const postInspection = normalizeInspectionRecord(postInspect, trip, preInspection);

    return <Document>
        <Page size="A4" style={reportStyles.page}>
            <ReportHeader title="Inspection Comparison Report" trip={trip} />
            <Section title="Trip Summary">
                <View style={reportStyles.grid}>
                    <InfoCell label="Client" value={trip?.client?.user?.name || trip?.clientName} />
                    <InfoCell label="Vehicle Reg" value={trip?.vehicleRegNumber || trip?.VehicleRegNo || preInspection?.regsitrationNumber} />
                    <InfoCell label="Make / Model" value={`${compact(preInspection?.make)} ${compact(preInspection?.model)}`} />
                    <InfoCell label="Status" value={TRIP_STATUSES[trip?.status] || trip?.status} />
                    <InfoCell label="Pickup" value={trip?.pickUp} style={{ width: "49%" }} />
                    <InfoCell label="Dropoff" value={trip?.dropOff} style={{ width: "49%" }} />
                </View>
            </Section>
            <Text style={{ ...compareStyles.sectionHeading, marginTop: 10 }}>Direct Pre vs Post Inspection Inputs</Text>
            <View style={{ flexDirection: "row", gap: 8, marginTop: 10 }}>
                <CompareColumn title="Pre inspection">
                    <View style={compareStyles.fieldGrid}>
                        <CompareField label="Client Ref" value={preInspection?.refNumber} />
                        <CompareField label="Reg" value={preInspection?.regsitrationNumber} />
                        <CompareField label="Make" value={preInspection?.make} />
                        <CompareField label="Model" value={preInspection?.model} />
                        <CompareField label="Colour" value={preInspection?.colour} />
                        <CompareField label="Opening km" value={preInspection?.kmsOut} />
                        <CompareField label="Date out" value={formatInspectionDate(preInspection?.dateOut)} />
                        <CompareField label="Time out" value={formatInspectionTime(preInspection?.timeOut)} />
                        <CompareField label="Source" value={preInspection?.source} />
                        <CompareField label="Destination" value={preInspection?.destination} />
                        <CompareField label="Fuel" value={compactBool(preInspection?.fuel)} />
                        <CompareField label="Driver" value={preInspection?.driver?.user?.name || preInspection?.driverName} />
                    </View>
                    <Text style={{ ...compareStyles.subsectionHeading, marginTop: 8 }}>Odometer / licence / e-tag</Text>
                    <View style={compareStyles.imageRow}>
                        <CompareImage label="Odometer" resource={preInspection?.odometer} />
                        <CompareImage label="Licence disk" resource={preInspection?.licenseDiskImage} />
                    </View>
                    <CompareImage label="E-tag" resource={preInspection?.etagImage} style={compareStyles.fullImageBox} />
                </CompareColumn>
                <CompareColumn title="Post inspection">
                    <View style={compareStyles.fieldGrid}>
                        <CompareField label="Client Ref" value={postInspection?.refNumber} />
                        <CompareField label="Reg" value={postInspection?.regsitrationNumber} />
                        <CompareField label="Make" value={postInspection?.make} />
                        <CompareField label="Model" value={postInspection?.model} />
                        <CompareField label="Colour" value={postInspection?.colour} />
                        <CompareField label="Closing km" value={postInspection?.kmsOut} />
                        <CompareField label="Date out" value={formatInspectionDate(postInspection?.dateOut)} />
                        <CompareField label="Time out" value={formatInspectionTime(postInspection?.timeOut)} />
                        <CompareField label="Source" value={postInspection?.source} />
                        <CompareField label="Destination" value={postInspection?.destination} />
                        <CompareField label="Fuel" value={compactBool(postInspection?.fuel)} />
                        <CompareField label="Driver" value={postInspection?.driver?.user?.name || postInspection?.driverName} />
                    </View>
                    <Text style={{ ...compareStyles.subsectionHeading, marginTop: 8 }}>Odometer / licence / e-tag</Text>
                    <View style={compareStyles.imageRow}>
                        <CompareImage label="Odometer" resource={postInspection?.odometer} />
                        <CompareImage label="Licence disk" resource={postInspection?.licenseDiskImage} />
                    </View>
                    <CompareImage label="E-tag" resource={postInspection?.etagImage} style={compareStyles.fullImageBox} />
                </CompareColumn>
            </View>
            <ComplianceSummary compliance={compliance} />
        </Page>
        <Page size="A4" style={reportStyles.page}>
            <ReportHeader title="Vehicle Damage Comparison" trip={trip} />
            <CompareAreaRow title="Left side" pre={{ images: preInspection?.leftPics, dent: preInspection?.leftDent, scratch: preInspection?.leftScratch, comment: preInspection?.leftCommnet }} post={{ images: postInspection?.leftPics, dent: postInspection?.leftDent, scratch: postInspection?.leftScratch, comment: postInspection?.leftCommnet }} />
            <CompareAreaRow title="Right side" pre={{ images: preInspection?.rightPics, dent: preInspection?.rightDent, scratch: preInspection?.rightScratch, comment: preInspection?.rightComment }} post={{ images: postInspection?.rightPics, dent: postInspection?.rightDent, scratch: postInspection?.rightScratch, comment: postInspection?.rightComment }} />
            <CompareAreaRow title="Front" pre={{ images: preInspection?.frontPics, dent: preInspection?.frontDent, scratch: preInspection?.frontScratch, comment: preInspection?.frontComment }} post={{ images: postInspection?.frontPics, dent: postInspection?.frontDent, scratch: postInspection?.frontScratch, comment: postInspection?.frontComment }} />
            <CompareAreaRow title="Rear" pre={{ images: preInspection?.backPics, dent: preInspection?.backDent, scratch: preInspection?.backScratch, comment: preInspection?.backComment }} post={{ images: postInspection?.backPics, dent: postInspection?.backDent, scratch: postInspection?.backScratch, comment: postInspection?.backComment }} />
            <CompareAreaRow title="Windscreen" pre={{ images: preInspection?.windScreenPics, dent: null, scratch: null, comment: preInspection?.windScreenComment }} post={{ images: postInspection?.windScreenPics, dent: null, scratch: null, comment: postInspection?.windScreenComment }} />
        </Page>
        <Page size="A4" style={reportStyles.page}>
            <ReportHeader title="Tyres And Sign-Off Comparison" trip={trip} />
            <CompareTyreRow title="Left front tyre" pre={{ images: preInspection?.leftFrontTirePics, tread: preInspection?.leftFrontTireTread, pressure: preInspection?.leftFrontTirePressure, make: preInspection?.leftFrontTireMake }} post={{ images: postInspection?.leftFrontTirePics, tread: postInspection?.leftFrontTireTread, pressure: postInspection?.leftFrontTirePressure, make: postInspection?.leftFrontTireMake }} />
            <CompareTyreRow title="Left rear tyre" pre={{ images: preInspection?.leftBackTirePics, tread: preInspection?.leftBackTireTread, pressure: preInspection?.leftBackTirePressure, make: preInspection?.leftBackTireMake }} post={{ images: postInspection?.leftBackTirePics, tread: postInspection?.leftBackTireTread, pressure: postInspection?.leftBackTirePressure, make: postInspection?.leftBackTireMake }} />
            <CompareTyreRow title="Right front tyre" pre={{ images: preInspection?.rightFrontTirePics, tread: preInspection?.rightFrontTireTread, pressure: preInspection?.rightFrontTirePressure, make: preInspection?.rightFrontTireMake }} post={{ images: postInspection?.rightFrontTirePics, tread: postInspection?.rightFrontTireTread, pressure: postInspection?.rightFrontTirePressure, make: postInspection?.rightFrontTireMake }} />
            <CompareTyreRow title="Right rear tyre" pre={{ images: preInspection?.rightBackTirePics, tread: preInspection?.rightBackTireTread, pressure: preInspection?.rightBackTirePressure, make: preInspection?.rightBackTireMake }} post={{ images: postInspection?.rightBackTirePics, tread: postInspection?.rightBackTireTread, pressure: postInspection?.rightBackTirePressure, make: postInspection?.rightBackTireMake }} />
            <View style={compareStyles.row}>
                <SignOffColumn title="Pre inspection sign-off" inspection={preInspection} />
                <SignOffColumn title="Post inspection sign-off" inspection={postInspection} />
            </View>
        </Page>
    </Document>
}

// eslint-disable-next-line no-unused-vars
const LegacyCompareDocument = ({ inspect, postInspect, trip, post = false }) => {
    const preInspection = normalizeInspectionRecord(inspect, trip);
    const postInspection = normalizeInspectionRecord(postInspect, trip, preInspection);

    return <Document>
        <Page size="A4">
            <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <Text style={{ alignSelf: 'center' }}>Inspection For Trip Order MYC#{trip?.id}</Text>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <Text style={{ width: "50%", textAlign: 'center' }}>Pre inspection</Text>
                    <Text style={{ width: "50%", textAlign: 'center' }}>Post inspection</Text>
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Client Reference Number" value={preInspection?.refNumber || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Client Reference Number" value={postInspection?.refNumber || "Not available"} style={{ flex: 1 }} />
                </View>

                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Registration Number" value={preInspection?.regsitrationNumber || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Registration Number" value={postInspection?.regsitrationNumber || "Not available"} style={{ flex: 1 }} />
                </View>

                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Make" value={preInspection?.make || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Make" value={postInspection?.make || "Not available"} style={{ flex: 1 }} />
                </View>

                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Model" value={preInspection?.model || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Model" value={postInspection?.model || "Not available"} style={{ flex: 1 }} />
                </View>

                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Colour" value={preInspection?.colour || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Colour" value={postInspection?.colour || "Not available"} style={{ flex: 1 }} />
                </View>

                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Date Out" value={formatInspectionDate(preInspection?.dateOut)} style={{ flex: 1 }} />
                    <FieldPara label="Date Out" value={formatInspectionDate(postInspection?.dateOut)} style={{ flex: 1 }} />
                </View>

                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="KMs Out" value={preInspection?.kmsOut || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="KMs Out" value={postInspection?.kmsOut || "Not available"} style={{ flex: 1 }} />
                </View>
            </View>
        </Page>
        <Page size="A4">
            <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <Text style={{ alignSelf: 'center' }}>Odometer</Text>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <PdfImage resource={preInspection?.odometer} style={{ width: 150, height: 150, alignSelf: 'center', objectFit: 'contain', flex: 1 }} />
                    <PdfImage resource={postInspection?.odometer} style={{ width: 150, height: 150, alignSelf: 'center', objectFit: 'contain', flex: 1 }} />
                </View>
                <Text style={{ alignSelf: 'center' }}>Licence Disk</Text>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <PdfImage resource={preInspection?.licenseDiskImage} style={{ width: 150, height: 150, alignSelf: 'center', objectFit: 'contain', flex: 1 }} />
                    <PdfImage resource={postInspection?.licenseDiskImage} style={{ width: 150, height: 150, alignSelf: 'center', objectFit: 'contain', flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Time Out" value={formatInspectionTime(preInspection?.timeOut)} style={{ flex: 1 }} />
                    <FieldPara label="Time Out" value={formatInspectionTime(postInspection?.timeOut)} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="From (source)" value={preInspection?.source || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="From (source)" value={postInspection?.source || "Not available"} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="To (destination)" value={preInspection?.destination || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="To (destination)" value={postInspection?.destination || "Not available"} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Fuel" yes={preInspection?.fuel} style={{ flex: 1 }} />
                    <ChoiceView label="Fuel" yes={postInspection?.fuel} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Type" value={preInspection?.type || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Type" value={postInspection?.type || "Not available"} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Driver" value={preInspection?.driver?.user?.name || preInspection?.driverName || "Not available"} style={{ flex: 1 }} />
                    <FieldPara label="Driver" value={postInspection?.driver?.user?.name || postInspection?.driverName || "Not available"} style={{ flex: 1 }} />
                </View>
            </View>

        </Page>
        <Page size="A4">
            <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <Text style={{ alignSelf: 'center' }}>Vehicle Inspection</Text>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <VehicleReviewBlock label="Left Side" dent={preInspection?.leftDent} scratch={preInspection?.leftScratch} comment={preInspection?.leftCommnet} image={preInspection?.leftPics} width={"50%"} />
                    <VehicleReviewBlock label="Left Side" dent={postInspection?.leftDent} scratch={postInspection?.leftScratch} comment={postInspection?.leftCommnet} image={postInspection?.leftPics} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <VehicleReviewBlock label="Right Side" dent={preInspection?.rightDent} scratch={preInspection?.rightScratch} comment={preInspection?.rightComment} image={preInspection?.rightPics} width={"50%"} />
                    <VehicleReviewBlock label="Right Side" dent={postInspection?.rightDent} scratch={postInspection?.rightScratch} comment={postInspection?.rightComment} image={postInspection?.rightPics} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <VehicleReviewBlock label="Car Front" dent={preInspection?.frontDent} scratch={preInspection?.frontScratch} comment={preInspection?.frontComment} image={preInspection?.frontPics} width={"50%"} />
                    <VehicleReviewBlock label="Car Front" dent={postInspection?.frontDent} scratch={postInspection?.frontScratch} comment={postInspection?.frontComment} image={postInspection?.frontPics} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <VehicleReviewBlock label="Car Rear" dent={preInspection?.backDent} scratch={preInspection?.backScratch} comment={preInspection?.backComment} image={preInspection?.backPics} width={"50%"} />
                    <VehicleReviewBlock label="Car Rear" dent={postInspection?.backDent} scratch={postInspection?.backScratch} comment={postInspection?.backComment} image={postInspection?.backPics} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <VehicleReviewBlock windscreen label="Windscreen" dent={false} scratch={false} comment={preInspection?.windScreenComment} image={preInspection?.windScreenPics} width={"50%"} />
                    <VehicleReviewBlock windscreen label="Windscreen" dent={false} scratch={false} comment={postInspection?.windScreenComment} image={postInspection?.windScreenPics} width={"50%"} />
                </View>

                <Text style={{ alignSelf: 'center' }}>Tyre Inspection</Text>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <TyreReviewBlock label="Left Front Tyre" tread={preInspection?.leftFrontTireTread} pressure={preInspection?.leftFrontTirePressure} image={preInspection?.leftFrontTirePics} make={preInspection?.leftFrontTireMake} width={"50%"} />
                    <TyreReviewBlock label="Left Front Tyre" tread={postInspection?.leftFrontTireTread} pressure={postInspection?.leftFrontTirePressure} image={postInspection?.leftFrontTirePics} make={postInspection?.leftFrontTireMake} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <TyreReviewBlock label="Left Back Tyre" tread={preInspection?.leftBackTireTread} pressure={preInspection?.leftBackTirePressure} image={preInspection?.leftBackTirePics} make={preInspection?.leftBackTireMake} width={"50%"} />
                    <TyreReviewBlock label="Left Back Tyre" tread={postInspection?.leftBackTireTread} pressure={postInspection?.leftBackTirePressure} image={postInspection?.leftBackTirePics} make={postInspection?.leftBackTireMake} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <TyreReviewBlock label="Right Back Tyre" tread={preInspection?.rightFrontTireTread} pressure={preInspection?.rightFrontTirePressure} image={preInspection?.rightFrontTirePics} make={preInspection?.rightFrontTireMake} width={"50%"} />
                    <TyreReviewBlock label="Right Back Tyre" tread={postInspection?.rightFrontTireTread} pressure={postInspection?.rightFrontTirePressure} image={postInspection?.rightFrontTirePics} make={postInspection?.rightFrontTireMake} width={"50%"} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <TyreReviewBlock label="Right Front Tyre" tread={preInspection?.rightBackTireTread} pressure={preInspection?.rightBackTirePressure} image={preInspection?.rightBackTirePics} make={preInspection?.rightBackTireMake} width={"50%"} />
                    <TyreReviewBlock label="Right Front Tyre" tread={postInspection?.rightBackTireTread} pressure={postInspection?.rightBackTirePressure} image={postInspection?.rightBackTirePics} make={postInspection?.rightBackTireMake} width={"50%"} />
                </View>


                <Text style={{ alignSelf: 'center' }}>Sign Off</Text>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="E Tag" yes={preInspection?.etag} style={{ flex: 1 }} />
                    <ChoiceView label="E Tag" yes={postInspection?.etag} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Tools & Jack" yes={preInspection?.toolsAndJack} style={{ flex: 1 }} />
                    <ChoiceView label="Tools & Jack" yes={postInspection?.toolsAndJack} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Spare Wheel" yes={preInspection?.spareWheel} style={{ flex: 1 }} />
                    <ChoiceView label="Spare Wheel" yes={postInspection?.spareWheel} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Removal Hubcaps" yes={preInspection?.removableHubcaps} style={{ flex: 1 }} />
                    <ChoiceView label="Removal Hubcaps" yes={postInspection?.removableHubcaps} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Triangle" yes={preInspection?.triangle} style={{ flex: 1 }} />
                    <ChoiceView label="Triangle" yes={postInspection?.triangle} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Parcel Tray" yes={preInspection?.parcelTray} style={{ flex: 1 }} />
                    <ChoiceView label="Parcel Tray" yes={postInspection?.parcelTray} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Trailer" yes={preInspection?.trailer} style={{ flex: 1 }} />
                    <ChoiceView label="Trailer" yes={postInspection?.trailer} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <ChoiceView label="Tow Bar" yes={preInspection?.towBar} style={{ flex: 1 }} />
                    <ChoiceView label="Tow Bar" yes={postInspection?.towBar} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Date" value={formatInspectionDateTime(preInspection?.createdAt)} style={{ flex: 1 }} />
                    <FieldPara label="Date" value={formatInspectionDateTime(postInspection?.createdAt)} style={{ flex: 1 }} />
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Company Name" style={{ flex: 1 }}>{preInspection?.companyName || "Not available"}</FieldPara>
                    <FieldPara label="Company Name" style={{ flex: 1 }}>{postInspection?.companyName || "Not available"}</FieldPara>
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Region" style={{ flex: 1 }}>{preInspection?.region || "Not available"}</FieldPara>
                    <FieldPara label="Region" style={{ flex: 1 }}>{postInspection?.region || "Not available"}</FieldPara>
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Dispatcher - name" style={{ flex: 1 }}>{preInspection?.personName || "Not available"}</FieldPara>
                    <FieldPara label="Dispatcher - name" style={{ flex: 1 }}>{postInspection?.personName || "Not available"}</FieldPara>
                </View>
                <View style={{ flexDirection: 'row', gap: 5, alignItems: 'flex-start' }}>
                    <FieldPara label="Mobile number" style={{ flex: 1 }}>{preInspection?.number || "Not available"}</FieldPara>
                    <FieldPara label="Mobile number" style={{ flex: 1 }}>{postInspection?.number || "Not available"}</FieldPara>
                </View>
            </View>

        </Page>
        <Page size="A4">
            <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <Text>Pre inspection</Text>
                <InspectPage4 inspect={inspect} />
                <Text>Post inspection</Text>
                <InspectPage4 inspect={postInspect} />
            </View>
        </Page>
    </Document>
}
const InspectPage1 = ({ inspect, width, trip }) => {
    const inspection = normalizeInspectionRecord(inspect, trip);
    return <View style={{ alignSelf: 'center', width, flexDirection: 'column', gap: 10 }}>
        <FieldPara label="Client Reference Number" value={inspection?.refNumber || "Not available"} />
        <FieldPara label="Registration Number" value={inspection?.regsitrationNumber || "Not available"} />
        <FieldPara label="Make" value={inspection?.make || "Not available"} />
        <FieldPara label="Model" value={inspection?.model || "Not available"} />
        <FieldPara label="Colour" value={inspection?.colour || "Not available"} />
        <FieldPara label="Date Out" value={formatInspectionDate(inspection?.dateOut)} />
        <FieldPara label="KMs Out" value={inspection?.kmsOut || "Not available"} />
    </View>
}

const InspectPage2 = ({ inspect, width = "70%", trip }) => {
    const inspection = normalizeInspectionRecord(inspect, trip);
    return <View style={{ alignSelf: 'center', width, flexDirection: 'column', gap: 10 }}>
        <Text style={{ alignSelf: 'center' }}>Odometer</Text>
        <PdfImage resource={inspection?.odometer} style={{ width: 150, height: 150, alignSelf: 'center', objectFit: 'contain' }} />
        <Text style={{ alignSelf: 'center' }}>Licence Disk</Text>
        <PdfImage resource={inspection?.licenseDiskImage} style={{ width: 150, height: 150, alignSelf: 'center', objectFit: 'contain' }} />
        <FieldPara label="Time Out" value={formatInspectionTime(inspection?.timeOut)} />
        <FieldPara label="From (source)" value={inspection?.source || "Not available"} />
        <FieldPara label="To (destination)" value={inspection?.destination || "Not available"} />
        <ChoiceView label="Fuel" yes={inspection?.fuel} />
        <FieldPara label="Type" value={inspection?.type || "Not available"} />
        <FieldPara label="Driver" value={inspection?.driver?.user?.name || inspection?.driverName || "Not available"} />
    </View>
}


const InspectPage3 = ({ inspect, width = '70%', trip }) => {
    const inspection = normalizeInspectionRecord(inspect, trip);
    return <View style={{ alignSelf: 'center', width, flexDirection: 'column', gap: 10 }}>
        <Text style={{ alignSelf: 'center' }}>Vehicle Inspection</Text>
        <VehicleReviewBlock label="Left Side" dent={inspection?.leftDent} scratch={inspection?.leftScratch} comment={inspection?.leftCommnet} image={inspection?.leftPics} />
        <VehicleReviewBlock label="Right Side" dent={inspection?.rightDent} scratch={inspection?.rightScratch} comment={inspection?.rightComment} image={inspection?.rightPics} />
        <VehicleReviewBlock label="Car Front" dent={inspection?.frontDent} scratch={inspection?.frontScratch} comment={inspection?.frontComment} image={inspection?.frontPics} />
        <VehicleReviewBlock label="Car Rear" dent={inspection?.backDent} scratch={inspection?.backScratch} comment={inspection?.backComment} image={inspection?.backPics} />
        <VehicleReviewBlock windscreen label="Windscreen" dent={false} scratch={false} comment={inspection?.windScreenComment} image={inspection?.windScreenPics} />

        <Text style={{ alignSelf: 'center' }}>Tyre Inspection</Text>
        <TyreReviewBlock label="Left Front Tyre" tread={inspection?.leftFrontTireTread} pressure={inspection?.leftFrontTirePressure} image={inspection?.leftFrontTirePics} make={inspection?.leftFrontTireMake} />
        <TyreReviewBlock label="Left Back Tyre" tread={inspection?.leftBackTireTread} pressure={inspection?.leftBackTirePressure} image={inspection?.leftBackTirePics} make={inspection?.leftBackTireMake} />
        <TyreReviewBlock label="Right Back Tyre" tread={inspection?.rightFrontTireTread} pressure={inspection?.rightFrontTirePressure} image={inspection?.rightFrontTirePics} make={inspection?.rightFrontTireMake} />
        <TyreReviewBlock label="Right Front Tyre" tread={inspection?.rightBackTireTread} pressure={inspection?.rightBackTirePressure} image={inspection?.rightBackTirePics} make={inspection?.rightBackTireMake} />

        <Text style={{ alignSelf: 'center' }}>Sign Off</Text>
        <ChoiceView label="E Tag" yes={inspection?.etag} />
        <ChoiceView label="Tools & Jack" yes={inspection?.toolsAndJack} />
        <ChoiceView label="Spare Wheel" yes={inspection?.spareWheel} />
        <ChoiceView label="Removal Hubcaps" yes={inspection?.removableHubcaps} />
        <ChoiceView label="Triangle" yes={inspection?.triangle} />
        <ChoiceView label="Parcel Tray" yes={inspection?.parcelTray} />
        <ChoiceView label="Trailer" yes={inspection?.trailer} />
        <ChoiceView label="Tow Bar" yes={inspection?.towBar} />
        <FieldPara label="Date" value={formatInspectionDateTime(inspection?.createdAt)} />

        <FieldPara label="Company Name">{inspection?.companyName || "Not available"}</FieldPara>
        <FieldPara label="Region">{inspection?.region || "Not available"}</FieldPara>
        <FieldPara label="Dispatcher - name">{inspection?.personName || "Not available"}</FieldPara>
        <FieldPara label="Mobile number">{inspection?.number || "Not available"}</FieldPara>
    </View>
}

const InspectPage4 = ({ inspect, trip }) => {
    const inspection = normalizeInspectionRecord(inspect, trip);
    return <View style={{ alignSelf: 'center', width: '100%', flexDirection: 'column', gap: 10 }}>
        <Text>Signature</Text>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View style={{ flexDirection: 'col', padding: 10, gap: 20 }}>
                <Text>Driver Signature</Text>
                <PdfImage resource={inspection?.driverSignature} style={{ width: 50, height: 50, objectFit: 'contain' }} />
            </View>
            <View style={{ flexDirection: 'col', padding: 10, gap: 20 }}>
                <Text>Client Signature</Text>
                <PdfImage resource={inspection?.signature} style={{ width: 50, height: 50, objectFit: 'contain' }} />
            </View>
        </View>
    </View>

}


const InspectionModalPage = ({ inspect, trip, post = false }) => {
    return <>
        <Page size="A4">
            <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <Text>{post ? "Post-" : "Pre-"} Inspection For Trip Order MYC#{trip?.id}</Text>
                <InspectPage1 width="100%" inspect={inspect} trip={trip} />
            </View>
        </Page>
        <Page size="A4">
            <View style={{ flexDirection: 'column', padding: 10, gap: 5 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <InspectPage2 inspect={inspect} trip={trip} />
            </View>
        </Page>
        <Page size="A4">
            <InspectPage3 inspect={inspect} trip={trip} />
        </Page>
        <Page size="A4">
            <InspectPage4 inspect={inspect} trip={trip} />
        </Page>
    </>
}

export const InspectionDoc = ({ inspection, trip, post = false }) => {
    return <Document>
        <InspectionModalPage inspect={inspection} trip={trip} post={post} />
    </Document>
}

export const CompleteDoc = ({ inspection, postInspection, trip, acceptedStatus }) => {
    return <Document>
        <TripOrderCard trip={trip} acceptedStatus={acceptedStatus} />
        {trip?.status === TripStatus.Cancelled ? <CancelPage trip={trip} /> : <View />}
        {inspection?.data?.id && <InspectionModalPage inspect={inspection?.data} trip={trip} />}
        {postInspection?.data?.id && <InspectionModalPage inspect={postInspection?.data} trip={trip} post={true} />}
    </Document>
}


export const AccidentDoc = ({ accident }) => {
    return <Document>
        <Page>
            <View style={{ flexDirection: 'column', padding: 10, gap: 15 }}>
                <Image src={{ uri: Assets.LogoDark }} style={{ alignSelf: 'center', width: 50, height: 50, objectFit: 'contain' }} />
                <MyText>Accident Report for Trip MYC#{accident?.tripOrderId}</MyText>

                <FieldPara label="Name">{accident?.driverName}</FieldPara>
                <FieldPara label="Number">{accident?.driver?.user?.email}</FieldPara>
                <FieldPara label="Email">{accident?.driver?.user?.number}</FieldPara>
                <FieldPara label="Police Scene">{accident?.policeScene ? "YES" : "NO"}</FieldPara>
                <FieldPara label="SAPSAR">{accident?.sapsar}</FieldPara>
                <FieldPara label="Vehicle Towed">{accident?.vehicleTowed ? "YES" : "NO"}</FieldPara>
                <FieldPara label="Vehicle Make Model">{accident?.vehicleMakeModel}</FieldPara>
                <FieldPara label="Vehicle Reg No">{accident?.vehicleRegNo}</FieldPara>
                <FieldPara label="Location">{accident?.location}</FieldPara>
                <FieldPara label="Trip Order ID">MYC{accident?.tripOrderId}</FieldPara>
                <FieldPara label="Accident Date Time">{formatDateTimeZA(accident?.accidentDateTime)}</FieldPara>
                <FieldPara label="Driver Surname">{accident?.driverSurname}</FieldPara>
                <FieldPara label="Full Message" >{accident?.description}</FieldPara>
                {accident?.accidentReportPics?.map?.((M, index) => <PdfImage key={`accident-image-${index}`} resource={M?.image} style={{ height: 100, width: 100, objectFit: 'contain', alignSelf: 'center' }} />)}

            </View>
        </Page>
    </Document>
}
